import React, { useContext, type PropsWithChildren } from 'react';
import type { SidePanelSubject } from '../types';
import { SidePanelLayout } from './components/SidePanelLayout';
import { SidePanelSurfaceContext } from './contexts/SidePanelSurfaceContext';

export type EnsureSidePanelSurfaceProps = PropsWithChildren<{
    subject?: SidePanelSubject | null;
}>;

export function EnsureSidePanelSurface({ children, subject = null }: EnsureSidePanelSurfaceProps) {
    const hasSurfaceAbove = useContext(SidePanelSurfaceContext);
    if (hasSurfaceAbove) {
        return <>{children}</>;
    }

    return (
        <SidePanelLayout panels={[]} subject={subject} hideHeader>
            {children}
        </SidePanelLayout>
    );
}
